import type { Adventure } from '../../types'

// Age 4: Cookie Sharing - Subtraction with Friends
export const cookieSharingAdventure: Adventure = {
  id: 'cookie-sharing',
  title: 'Cookie Sharing Fun',
  theme: 'subtraction',
  targetAge: '4',
  difficulty: 'easy',
  estimatedDuration: 6,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello friend! Today we are baking and sharing cookies! When we share, we give some away. That is subtraction! Ready?",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "Yum! I have 5 warm cookies on my plate! If I share 2 cookies with my friend, how many cookies do I have left?",
      duration: 6,
      background: 'kitchen-cozy'
    },
    choice1: [
      {
        id: 'share-cookies',
        label: "Share them!",
        tillyLine: "Sharing is caring! 5 cookies minus 2 cookies equals...?",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition',
      question: '5 - 2 = ?',
      tillyPrompt: 'How many cookies left?',
      options: [
        { id: '2', label: '2', isCorrect: false },
        { id: '3', label: '3', isCorrect: true },
        { id: '4', label: '4', isCorrect: false }
      ],
      num1: 5,
      num2: 2
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Delicious! 5 minus 2 equals 3! You have 3 cookies left! Now I have 7 cookies and I share 3 with family!",
      duration: 6,
      background: 'kitchen-cozy'
    },
    choice2: [
      {
        id: 'share-more',
        label: "Share more!",
        tillyLine: "Sharing with family! 7 cookies minus 3 cookies equals...?",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '7 - 3 = ?',
      tillyPrompt: 'Cookies left after sharing?',
      options: [
        { id: '3', label: '3', isCorrect: false },
        { id: '4', label: '4', isCorrect: true },
        { id: '5', label: '5', isCorrect: false }
      ],
      num1: 7,
      num2: 3
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You are a sharing superstar! Big cookie challenge - 8 cookies and sharing 5 with friends!",
        duration: 5,
        background: 'kitchen-cozy'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'simple-addition',
          question: '8 - 5 = ?',
          tillyPrompt: 'What is 8 minus 5?',
          options: [
            { id: '2', label: '2', isCorrect: false },
            { id: '3', label: '3', isCorrect: true },
            { id: '4', label: '4', isCorrect: false }
          ],
          num1: 8,
          num2: 5
        } as any
      ]
    },
    reward: {
      tillyLine: "Sweet success! You know how to share and subtract! You are a Cookie Sharing Champion!",
      badgeName: 'Cookie Sharing Champion',
      badgeIcon: '🍪',
      nextPreview: 'Next time, we will find shape patterns!'
    }
  }
}

export const tillyCookieCorrect = [
  "Yummy! That is right!",
  "Sweet! You got it!",
  "Cookie-tastic! Perfect!",
  "Delicious counting! Amazing!",
  "Fresh from the oven correct!",
  "Baked to perfection! You did it!",
  "Chocolate chip champion!",
  "Warm and wonderful answer!",
  "Sugar sweet success! Great job!",
  "Best cookie counter ever!"
]

export const tillyCookieWrong = [
  "Almost! Count the cookies!",
  "Not quite! Try again!",
  "Good try! Sharing is tricky!",
  "Close! How many cookies left?",
  "That is okay! Cookies can be hard!",
  "Keep trying! You will get it!",
  "Almost there! One more bite!",
  "Try once more! You can do it!",
  "Not there yet! Keep sharing!",
  "Crumbly close! Try again!"
]

export const tillyCookieCelebration = [
  "🍪 Fresh baked success! 🍪",
  "Cookie champion of the kitchen! 🌟",
  "Sweet victory for you! 🏆",
  "Best cookie sharer ever! 🎊",
  "Yum yum! You did it! 🥇"
]
